import { TreeLikeFlatNode, TreeLikeNode } from '@src/suite/common/data-models/search-results/search-results';

export const getNodeLevel = ({ level }: TreeLikeFlatNode<StorytellingWireRecord>) => {
    return level;
};

// Function that determines whether a flat node is expandable or not
export const getIsNodeExpandable = ({ hasChildren }: TreeLikeFlatNode<StorytellingWireRecord>) => {
    return hasChildren;
};

// Function that returns a nested node's list of children
export const getNodeChildren = ({ children }: TreeLikeNode<StorytellingWireRecord>) => {
    return children;
};

// Function that maps a nested node to a flat node
export const nodeTransformer = (node: TreeLikeNode<StorytellingWireRecord>, level: number): TreeLikeFlatNode<StorytellingWireRecord> => {
    return {
        id: node.id,
        label: node.label,
        uniqueId: node.uniqueId,
        index: node.index,
        itemsCount: node.itemsCount,
        level,
        hasChildren: node?.children?.length > 0,
        object: node.object,
        nodeLastInGroup: node.nodeLastInGroup,
        nodeFirstInGroup: node.nodeFirstInGroup,
        linkedRecordType: node?.linkedRecordType,
        isMetadata: node?.isMetadata,
        isNewItems: node?.isNewItems,
        cost: node?.cost,
    };
};
